/** Measures active product-page attention, never list impressions or hidden-tab time. */
export function mountProductEngagement(report:(metadata:Record<string,unknown>)=>void):()=>void {
 let identity='',active=0,sent=0,last=Date.now(),interaction=Date.now();
 const touch=()=>{interaction=Date.now();};
 for(const event of ['pointerdown','pointermove','keydown','scroll','touchstart'])window.addEventListener(event,touch,{passive:true});
 const tick=()=>{
  const now=Date.now(),elapsed=Math.min(1500,Math.max(0,now-last));last=now;
  if(document.visibilityState!=='visible'||!document.hasFocus())return;
  const widget=document.querySelector('smartyfind-search');
  const overlay=widget?.shadowRoot?.querySelector('.sf-output:not([hidden]), [role="dialog"]:not([hidden])');
  if(overlay&&overlay.getBoundingClientRect().height>0)return;
  const title=document.querySelector('.page--product-details h1, h1.product_title, [itemtype$="/Product"] [itemprop="name"]');
  if(!title)return;
  const name=(title.textContent??'').replace(/\s+/g,' ').trim().slice(0,300);if(!name)return;
  const url=new URL(location.href);url.hash='';url.search='';
  if(identity!==url.href){identity=url.href;active=0;sent=0;interaction=now;return;}
  if(now-interaction>45000)return;
  active+=elapsed;
  const thresholds=[15000,45000,120000];
  if(sent>=thresholds.length||active<thresholds[sent]!)return;
  sent++;
  report({surface:'product-page',name,productUrl:url.href,activeMs:Math.round(active),engaged:true,internalTraffic:!!document.getElementById('wpadminbar')});
 };
 const timer=window.setInterval(tick,1000);tick();
 return()=>{clearInterval(timer);for(const event of ['pointerdown','pointermove','keydown','scroll','touchstart'])window.removeEventListener(event,touch);};
}
